<template>
<div class="main mt15 p34">
	<div class="my-title">{{info.productName}}</div>
    <div class="recognize-table mt10">
		<Button type="info" @click="add" v-if="!isReset">添加人员</Button>
		<Button type="info" @click="batch" v-if="!isReset">批量批单</Button>
		<span v-if="fiveRisk" class="errorMsg">5类人员占比超过50%，<b>新增人员</b>保费上浮20%，上浮保费已标红色。</span>
		<eTable :list="orderData" ref="table">
			<el-table-column type="index" label="序号" width="70" align="center" :index="indexMethod" fixed></el-table-column>
			<el-table-column prop="isAerial" label="是否高空" width="100">
				<template slot-scope="{ row }">
					{{row.isAerial?'高空':'非高空'}}
				</template>
			</el-table-column>
			<el-table-column prop="insuranceSchemeName" label="选择计划" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="insurantName" label="姓名" width="100"></el-table-column>
			<el-table-column prop="insurantCertificateNumber" label="证件号码" width="190">
				<template slot-scope="{ row }">
					{{hideIdCard(row.insurantCertificateNumber)}}
				</template>
			</el-table-column>
			<el-table-column prop="insurantGenderName" label="性别" width="70"></el-table-column>
			<el-table-column prop="insurantAge" label="年龄" width="70"></el-table-column>
			<el-table-column prop="jobTypeName" label="职业/工种" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="insuranceStatusName" label="状态" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="effectiveDateStart" label="保障起期" width="120"></el-table-column>
			<el-table-column prop="effectiveDateEnd" label="保障止期" width="120"></el-table-column>
			<el-table-column prop="insurantAmount" label="费用" width="120">
				<template slot-scope="{ row }">
					<span :style="{color:row.fiveRisk?'red':'#333'}">{{row.insurantAmount}}{{row.insurantAmount=='-'?'':'元'}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="remarks" label="备注" show-overflow-tooltip width="160">
				<template slot-scope="{ row }">
					<span :style="{color:row.status==0?'#333':'red'}">{{row.remarks}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="130" fixed="right">
				<template slot-scope="scope" v-if="!isReset">
					<a v-if="channel=='QZG'&&scope.row.status==0" @click="openEdit(scope.row)">编辑</a>
					<a v-if="channel=='QZG'&&scope.row.status==0" @click="openRelace(scope.row)">替换</a>
					<!-- <a v-if="channel=='QZG'&&row.status==0" @click="refund(row,index)">退保</a> -->
					<a v-if="scope.row.status==1" @click="delList(scope.row)">删除</a>
					<a v-if="channel=='QZG'&&(scope.row.status==2||scope.row.status==3||scope.row.status==4)" @click="recall(scope.row,scope.$index)">撤回</a>
				</template>
			</el-table-column>
		</eTable>
    </div>
	<div class="mt10 center">
		<Button type="success" @click="sub" :disabled="!canSub">提交信息</Button>
	</div>
	<Modal
		v-model="addShow"
		title="添加人员信息"
        width="400px"
        :mask-closable="false">
		<Form :model="addForm" ref="addForm" :label-width="100" :rules="addFormRules">
			<FormItem label="姓名" prop="insurantName">
		        <Input type="text" v-model="addForm.insurantName" ></Input>
		    </FormItem>
		    <FormItem label="证件号" prop="insurantCertificateNumber">
		        <Input type="text" v-model="addForm.insurantCertificateNumber" ></Input>
		    </FormItem>
			<FormItem label="是否高空" prop="isAerial">
				<Select v-model="addForm.isAerial" @on-change="val=>aerialChange(val)" transfer>
					<Option value="1" v-if="isAerial">高空</Option>
					<Option value="0" v-if="isNoAerial">非高空</Option>
				</Select>
		    </FormItem>
			<template v-if="addForm.isAerial">
				<FormItem label="工种" prop="jobTypeCode">
					<SelectJob :value="addForm.jobTypeCode" productCode="GSCGZZRX" @change="val=>jobChange(val,'addForm')"/>
					<!-- <Select v-model="addForm.jobTypeCode" @on-change="jobTypeChange" v-else>
						<Option :value="item.workTypeCode" v-for="(item, index) in jobList" :key="index">{{item.workTypeName}}</Option>
					</Select> -->
				</FormItem>
				<FormItem label="选择方案" prop="insuranceSchemeCode" v-if="addForm.jobTypeCode" key="caseListAll">
					<Select v-model="addForm.insuranceSchemeCode" placeholder="请选择保障方案" transfer>
						<Option :value="item.planCode" v-for="(item, index) in caseListAll" :key="index">{{item.planName}}</Option>
					</Select>
				</FormItem>
				<!-- <FormItem label="选择方案" prop="insuranceSchemeCode" v-if="addForm.jobTypeCode" key="caseList">
					<Select v-model="addForm.insuranceSchemeCode" placeholder="请选择保障方案" transfer>
						<Option :value="item.planCode" v-for="(item, index) in caseList" :key="index">{{item.planName}}</Option>
					</Select>
				</FormItem> -->
			</template>
		</Form>
		<template slot="footer">
			<Button type="text" @click="addShow=false">取消</Button>
			<Button type="primary" @click="confirmAdd" >确定</Button>
		</template>
	</Modal>
	<Modal
		v-model="editShow"
		title="编辑人员信息"
        width="400px"
        :mask-closable="false">
		<Form :model="editForm" ref="editForm" :label-width="100" :rules="editFormRules" @submit.native.prevent>
			<FormItem label="姓名" prop="insurantName">
		        <Input type="text" v-model="editForm.insurantName" ></Input>
		    </FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="editShow=false">取消</Button>
			<Button type="primary" @click="confirmEdit">确定</Button>
		</template>
	</Modal>
	
	<Modal
		v-model="replaceShow"
		width="600px"
		title="人员替换"
        :mask-closable="false">
		<Card title="原员工">
			<Form :label-width="90">
				<Row>
					<Col span="12">
						<FormItem label="姓名：" class="mb0">
							{{replaceData.insurantName}}
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem label="职业工种：" class="mb0">
							{{replaceData.jobTypeName}}
						</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="24">
						<FormItem label="证件号：" class="mb0">
							{{replaceData.insurantCertificateNumber}}
						</FormItem>
					</Col>
					<Col span="24">
						<FormItem label="选择计划：" class="mb0">
							{{replaceData.insuranceSchemeName}}
						</FormItem>
					</Col>
				</Row>
			</Form>
		</Card>
		<Card title="替换后员工">
			<Alert type="warning">同原员工的保障方案、职业类别必须一致才能替换</Alert>
			<Form :model="replaceForm" ref="replaceForm" :label-width="80" :rules="replaceFormRules">
				<FormItem label="姓名" prop="insurantName">
					<Input type="text" v-model="replaceForm.insurantName" ></Input>
				</FormItem>
				<FormItem label="证件号" prop="insurantCertificateNumber">
					<Input type="text" v-model="replaceForm.insurantCertificateNumber" ></Input>
				</FormItem>
				<FormItem label="工种" prop="jobTypeCode">
					<SelectJob :value="replaceForm.jobTypeCode" productCode="GSCGZZRX" @change="val=>jobChange(val,'replaceForm')"/>
				</FormItem>
			</Form>
		</Card>
		
		<template slot="footer">
			<Button type="text" @click="replaceShow=false">取消</Button>
			<Button type="primary" :loading="replaceLoading" @click="confirmReplace" >确定</Button>
		</template>
	</Modal>
	<Modal
		v-model="confirmShow"
		title="人员信息变更"
        width="400px"
        :mask-closable="false">
		<Form :label-width="130">
			<FormItem label="姓名变化员工数：" v-if="confirmForm.nameCount">
		        {{confirmForm.nameCount}}人
		    </FormItem>
			<FormItem label="替换员工数：" v-if="confirmForm.changeCount">
		        {{confirmForm.changeCount}}人
		    </FormItem>
			<FormItem label="退出员工数：" v-if="confirmForm.quitCount">
		        {{confirmForm.quitCount}}人，合计退回 {{confirmForm.refAmount}}元
		    </FormItem>
			<FormItem label="新增人员：" v-if="confirmForm.addCount">
		        {{confirmForm.addCount}}人，合计应缴纳 {{confirmForm.amount}}元
		    </FormItem>
			<FormItem :label-width="20">
				本次编辑人员，{{confirmForm.finalAmount>=0?'合计需缴纳':'合计需退回'}}
		        {{Math.abs(confirmForm.finalAmount)}}元
		    </FormItem>
			<!-- <FormItem label="上传批改单：" v-if="confirmForm.finalAmount>=0"> -->
			<FormItem label="上传批改单：">
				点击下载批改单，盖章后上传<a @click="download">下载</a>
				<UploadFileImg 
					@on-success="val=>uploadSuccess(val)" 
					:accept="['image']"
					type="select" 
					btn-text="上传批改单"></UploadFileImg>
                    <div v-if="correctUrlList.length>0">
                        <p v-for="(item,index) in correctUrlList" >
                            批改单{{index+1}}&nbsp;&nbsp;&nbsp;<a :href="item" target="_blank" class="ml10" :key="index">查看</a>&nbsp;<a style="color:#ed4014" @click="del(index)">删除</a>
                        </p>
                    </div>
		    </FormItem>
		</Form>
		<template slot="footer">
			<span v-if="confirmForm.finalAmount<0" class="edit-warning">本产品不支持退费，此次修改无效</span>
			<Button type="text" @click="confirmShow=false" v-if="confirmForm.finalAmount<0">关闭</Button>
			<Button type="text" @click="confirmShow=false;confirmLoading=false;" v-if="confirmForm.finalAmount>=0">取消</Button>
			<Button type="primary" @click="confirmSub" :disabled="correctUrlList.length==0" v-if="confirmForm.finalAmount>=0" :loading="confirmLoading">确定</Button>
		</template>
	</Modal>
	<TrackNotice />
</div>
</template>
<script>
// 后端，状态2和3的可以在此页面编辑，并置换为前端状态0
// 1,"未完成","
// 3,"待生效","
// 2, "保障中","
// 6, "已失效",
// 前端，扩展
// (0, "承保"),原始数据
// (1, "新增"),
// (2, "编辑姓名"),
// (3, "退保"),
// (4, "替换新增"),
// (5, "被替换退保"),
import SelectJob from '@/components/common/SelectJob'
import UploadFileImg from '@/components/common/UploadFileImg'
import { caseList } from '../../../scheme/components/common/dictionary'
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
import eTable from '@/components/common/eTable'
export default {
	mixins:[ track ],
	components:{ SelectJob,UploadFileImg,TrackNotice,eTable },
	data () {
		return {
            correctUrlList:[],
            replaceLoading:false,
			info:{},
			originalList:[],// 原始数据
			id:this.$route.params.id,
			orderData:[],
			columns:[
                {type:'index',width:70,title:'序号',align: 'center',fixed:'left'},
                {title: '是否高空',slot: 'isAerial',width:100},
                {title: '选择计划',key: 'insuranceSchemeName',width:460},
                {title: '姓名',key: 'insurantName',width:100},
                {title: '证件号码',slot: "insurantCertificateNumber",width:190},
                {title: '性别',key: 'insurantGenderName',width:70},
                {title: '年龄',key: 'insurantAge',width:70},
				{title: '职业/工种',key: 'jobTypeName',width:150},
				{title: '状态',key: 'insuranceStatusName',width:80},
                {title: '保障起期',key: 'effectiveDateStart',width:180},
                {title: '保障止期',key: 'effectiveDateEnd',width:180},
                {title: '费用',slot: 'insurantAmount',width:120},
                {title: '备注',slot: 'remarks',width:115},
				{title: '操作',slot: "handle",width:130,fixed:'right'}
			],
			addShow:false,
			addForm:{},
			addFormRules:{
				insurantName:{required:true,message:'请填写姓名',trigger:'blur'},
				insurantCertificateNumber:{required:true,message:'请填写证件号',trigger:'blur'},
				jobTypeCode:{required:true,message:'请选择职业/工种',trigger:'change'},
				insuranceSchemeCode:{required:true,message:'请选择计划',trigger:'change'},
				isAerial:{required:true,message:'请选择高空/非高空',trigger:'change'},
			},
			editShow:false,
			editForm:{},
			editFormRules:{
				insurantName:{required:true,message:'请填写姓名',trigger:'blur'},
			},
			replaceShow:false,
			replaceData:{},
			replaceForm:{},
			replaceFormRules:{
				insurantName:{required:true,message:'请填写姓名',trigger:'blur'},
				insurantCertificateNumber:{required:true,message:'请填写证件号',trigger:'blur'},
				jobTypeCode:{required:true,message:'请选择职业/工种',trigger:'change'},
			},
			confirmShow:false,
			confirmForm:{},
			caseList:[],
			subList:[],
			correctUrl:'',
			confirmLoading:false,
			jobList:[],
			channel:'',
			isAerial:false, // 是否包含高空
			isNoAerial:false,// 是否包含非高空
			caseListAll:[],
			isReset:this.$route.query.reset||'', // reset=1重新投保
			orderNo:this.$route.query.orderNo||'',
		}
	},
	computed: {
		canSub(){
			let list=this.orderData.filter(item=>{
				return item.status!=0
			})
			return list.length>0
		},
		fiveRisk(){
			let fiveRisk=false
			this.orderData.forEach(item=>{
				if(item.fiveRisk)fiveRisk=true
			})
			return fiveRisk
		}
	},
	created () {
		this.getJobList();
		this.getInfo();
	},
	mounted(){
		this.track_is_new = true;
		this.$nextTick(()=>{
			this.trackInit();
		})
	},
	methods:{
		indexMethod(index) {
			return index + 1 + (this.$refs.table.pageParams.page- 1) * this.$refs.table.pageParams.count
		},
		// 获取方案列表
		getCaseList () {
			// 原逻辑 获取所有方案
			// this.$axios.post('/employerLiability/getSchemeList',{
			// 	productCode:this.info.productCode
			// }).then(res=>{
			// 	this.caseListAll = res;
			// });
			// 现逻辑 针对可选方案
			if(this.addForm.jobTypeCode&&this.addForm.isAerial){
				this.$axios.post('/employerLiability/queryUsablePlanList',{
					workTypeCode: this.addForm.jobTypeCode,
					policyId: this.id,
					isAerial: this.addForm.isAerial
				}).then(res=>{
					this.caseListAll = res;
				});
			}
			
		},
		aerialChange (val) {
			this.$set(this.addForm,'insuranceSchemeCode',''); // 方案重置
			// this.addForm.insuranceSchemeCode = ''
			// this.addForm.jobTypeCode = ''
			// this.$forceUpdate()
			// console.log(this.addForm)
			this.getCaseList();
		},
		// 获取已存在保单中职业工种和对应保障计划
		getJobList() {
			this.$axios.post('/employerLiability/queryUsableWorkType',{
				policyId:this.id
			}).then(res=>{
				this.jobList=res;
			});
		},
		// // 获取方案列表
		// getCaseList () {
		// 	this.$axios.post('/employerLiability/getSchemeList',{
		// 		productCode:this.info.productCode
		// 	}).then(res=>{
		// 		this.caseList=res;
		// 	});
		// },
		hideIdCard (str,frontLen=4,endLen=3) { 
			if(!str)return ''
			var len = str.length-frontLen-endLen;
			var star = '';
			for (var i=0;i<len;i++) {
				star+='*';
			}
			return str.substring(0,frontLen)+star+str.substring(str.length-endLen);
		},
		/*获取订单信息*/
		async getInfo () {
			let obj = {policyId:this.id}
			if (this.isReset)obj={orderNo:this.orderNo}
			let res = await this.$axios.post('/employerLiability/getDetailInfo.json',obj)
			this.info=res;
			this.channel=res.source;
			if (!this.isReset) {
				res.list=res.list.filter(item=>{
					if(item.insuranceStatus==2||item.insuranceStatus==3){
						item.status=0;
					}
					return item.status==0
				})
			} 
			// else {
			// 	res.list=res.list.filter(item=>{
			// 		return item.status!=2&item.status!=5
			// 	})
			// }
			this.originalList=this.jsonCopy(res.list);
			if (this.isReset) {
				let plist = this.jsonCopy(res.list)
				plist.map(item=>{
					item.id=''
					return item
				})
				// plist=plist.filter(item=>{
				// 	return item.status!=2&item.status!=5
				// })
				let alist = []
				let blist = []
				plist.forEach(item=>{
					if (item.status!=2&item.status!=5) {
						alist.push(item)
					} else {
						blist.push(item)
					}
				})
				this.orderData = await this.$axios.post('/employerLiability/editEmployeeInformation?productCode='+this.info.productCode+'.json',alist)
				this.orderData = this.orderData.concat(blist)
			} else {
				this.orderData=res.list;
			}
			res.list.forEach(el=>{
				if (el.isAerial) this.isAerial=true
				else this.isNoAerial=true
			})
		},
		checkPerson(insurantCertificateNumber) {
			let index=this.orderData.findIndex(item=>{
				return item.status!=3&&item.status!=5&&item.insurantCertificateNumber==insurantCertificateNumber
			})
			if(index>-1){
				this.alert('身份证号与列表人员重复，请核对身份证号。')
				return false
			}else{
				return true
			}
		},
		// 添加
		add() {
			this.addShow=true;
			this.addForm={
				isAerial:''
			};
			this.$refs.addForm.resetFields();
			console.log(this.addForm)
		},
		batch() {
			this.$router.push('/company-group-employergs/edit-batch/'+this.id)
		},
		// 确定
		confirmAdd(){
			console.log(this.addForm)
			// this.$refs.addForm.validateField('insuranceSchemeCode',valid=>{
			// 	console.log(valid)
			// })
			// this.$refs.addForm.validateField('jobTypeCode',valid=>{
			// 	console.log(valid)
			// })
			this.$refs.addForm.validate(valid=>{
				if(valid&&this.checkPerson(this.addForm.insurantCertificateNumber)){
					this.getPremium({
						...this.addForm,
						policyId:this.id,
					}).then(res=>{
						if(res){
							this.orderData.push({
								...res,
								remarks:'新增',
								insuranceStatusName:'新增'
							});
							this.addShow=false;
						}
						
					})
				}
			})
		},
		// 打开修改名字
		openEdit(row){
			this.editShow=true;
			this.editForm=this.jsonCopy(row);
			this.$refs.editForm.resetFields();
		},
		// 确定修改
		confirmEdit(){
			this.$refs.editForm.validate(valid=>{
				if(valid){
					let index=this.orderData.findIndex(item=>{
						return this.editForm.id==item.id
					})
					
					this.orderData.splice(index,1,{
						...this.editForm,
						status:2,
						remarks:'编辑',
						insuranceStatusName:'编辑'
					});
					this.editShow=false;
				}
			})
		},
		// 撤回
		recall(row,index){
			let text=''
			if(row.status==2){
				text='确定撤回编辑人员姓名？'
			}else if(row.status==3){
				// 退保
				text='确定撤回退保人员？'
			}else if(row.status==4){
				// 替换新增
				text='确定撤回替换人员？'
			}
			this.confirm(text,()=>{
				// 查找当前选中的数据
				let oIndex = this.orderData.findIndex(item => {
					return item.refId == row.refId
				})
				let originalCertificateNumber=row.status==4?this.orderData[oIndex-1].insurantCertificateNumber:row.insurantCertificateNumber
				let originalIndex=this.originalList.findIndex(item=>{
					return item.insurantCertificateNumber==originalCertificateNumber
				})
				if(row.status==4){
					this.orderData.splice(oIndex-1,1,this.originalList[originalIndex])
					this.orderData.splice(oIndex,1)
				}else{
					let Index = this.orderData.findIndex(item => {
						return item.id == row.id
					})
					this.orderData.splice(Index,1,this.originalList[originalIndex])
				}
				this.getPremium();
			})
		},
		// 删除新增
		delList(row) {
			this.confirm('确定删除新增人员？',()=>{
				this.orderData.forEach((item,inx)=>{
					if(item.insurantCertificateNumber==row.insurantCertificateNumber){
						this.orderData.splice(inx, 1)
					}
				})
				this.$refs.table.pageParams.page = 1;
				this.getPremium()
			})
		},
		// 退保
		refund(row,index) {
			this.confirm('确定该名员工退出保障计划吗？确认后，将把员工状态临时置为已失效，“提交信息”后才最终生效',()=>{
				this.getPremium({
					...row,
					policyId:this.id,
					status:3,
				}).then(res=>{
					this.orderData.splice(index,1,{
						...res,
						status:3,
						insuranceStatusName:'退出'
					});
				})
			})
		},
		// 价格格式化，最多2位小数
		numFormat(num){
			return Number(num.toString().match(/^\d+(?:\.\d{0,2})?/))
		},
		// 打开替换
		openRelace(row) {
			this.replaceShow=true;
			this.replaceData=row;
			this.replaceForm={};
			this.$refs.replaceForm.resetFields();
		},
		// 确定替换
		confirmReplace() {
			this.$refs.replaceForm.validate(valid=>{
				if(valid&&this.checkPerson(this.replaceForm.insurantCertificateNumber)){
					// if(this.replaceForm.jobCategory>parseInt(this.replaceData.riskTypeCode.split('_')[1])){
					// 	this.alert('请选择工种风险类别一致或低于被替换人的工种')
					// 	return
					// }
					
					// 替换人
                    this.replaceLoading = true
					this.getPremium({
						...this.replaceForm,
						refId:this.replaceData.id,
						policyId:this.id,
						// jobTypeCode:this.replaceData.jobTypeCode,
						insurancePlanCode:this.replaceData.insurancePlanCode,
					}).then(res=>{
                        if (!res) return
						let index=this.orderData.findIndex(item=>{
							return item.id==this.replaceData.id
						})
						this.orderData.splice(index+1,0,{
							...res,
							status:4,
							remarks:'替换',
							insuranceStatusName:'替换'
						})
						
						let effectiveDateEnd=(Date.parse(res.effectiveDateStart)-3600*1000*24)<Date.parse(this.orderData[index].effectiveDateStart)
							?this.orderData[index].effectiveDateStart
							:this.formatDate((Date.parse(res.effectiveDateStart)-3600*1000*24))
						this.orderData.splice(index,1,{
							...this.orderData[index],
							effectiveDateEnd:effectiveDateEnd,
							insurantAmount:'-',
							status:5,
							remarks:'被替换'
						})

						this.replaceShow=false;
                        this.replaceLoading = false
					});
				}
			})
		},
		// 提交
		sub() {
			this.confirm('确定提交信息？',()=>{
				let list=this.jsonCopy(this.orderData.filter(item=>{
					if (this.isReset) {
						return item
					} else {
						return item.status==1||item.status==2||item.status==3||item.status==4
					}
				}))
				list.forEach(item => {
					item.policyId=this.info.count||this.id
				});
				this.subList=list;
				this.subList=list.filter(item=>{
					return item.status!=5
				})
				this.$axios.post('/employerLiability/confirmAllEmployee.json',this.subList).then(res=>{
					this.confirmForm=res;
					this.confirmShow=true
				});
			})
			
		},
		// 确认跳转
		confirmSub() {
			this.confirmLoading=true;
			this.$axios.post('/employerLiability/confirmAndCreateOrder.json',{
				correctUrl:this.correctUrlList.join(','),
				vo:this.subList,
				productCode:this.info.productCode
			}).then(async res=>{
				this.confirmLoading=false;
				// 新增功能 无论订单金额多少都跳支付
				// if(this.confirmForm.finalAmount>0){
					// 跳转支付
				// 回溯 停止录制
				await this.stopRecord({
					session_key:sessionStorage.track_session_key,
					policy_id:res
				});
					window.location.replace(`/common.html#/new-pay?orderNo=${res}&productCode=${this.info.productCode}`)
				// }else if(this.confirmForm.finalAmount==0){
				// 	this.confirmShow=false
				// 	// 返回保单
				// 	this.$router.back();
				// }
			});
		},
		// 非高空选择工种
		jobTypeChange(val) {
			let jobItem=this.jobList.find(item=>{
				return item.workTypeCode==val
			})
			if(jobItem){
				this.caseList=jobItem.list;
			}
		},
		// 高空选择工种
		jobChange(val,key) {
			// this[key].jobTypeCode = val.value
			this.$set(this[key],'jobTypeCode',val.value)
			// this.jobTypeChange(val.value)
			if(key=='addForm'){
				this.$set(this.addForm,'insuranceSchemeCode',''); // 方案重置
				this.getCaseList()
			}
		},
		// 下载模板
		download() {
			this.exportToExcel('/employerLiability/exportCorrect',{
				uuid:this.confirmForm.uuid,
				policyId:this.info.count||this.id
			})
		},
		/*上传成功后获取数据*/
		uploadSuccess (res) {
			// this.correctUrl=res.url
            if(this.correctUrlList.length<9) {
                this.correctUrlList.push(res.url)
            } else {
                this.alert('最多上传9张批改单！')
            }
            
		},
        del (index) {
            this.correctUrlList.splice(index, 1)
        },
		// 保费计算
		getPremium(form) {
			let list=this.orderData.filter(item=>{
				item.policyId=this.id
				return item.status==1||item.status==3||item.status==4
			})
			if(form)list.push(form)
			if(list.length==0)return
			// return this.$axios.post('/employerLiability/editEmployeeInformation.json',list).then(res=>{
			return this.$axios.post('/employerLiability/editEmployeeInformation?productCode='+this.info.productCode+'.json.all',list).then(result=>{
                this.replaceLoading = false
                if (result.code !== 10000000) {
                    this.alert(result.msg)
                    return
                }
                let res = result.data
                this.orderData.forEach((item,index)=>{
					let addItem=res.find(resItem=>{
						return item.status==1&&item.insurantCertificateNumber==resItem.insurantCertificateNumber
					})
					if(addItem){
						this.orderData.splice(index,1,{
							...item,
							...addItem
						})
					}
				})
				if(form){
					let item=res.find(item=>{
						return item.insurantCertificateNumber==form.insurantCertificateNumber
					})
					return item
				}
			})
		}
	}
}
</script>
<style scoped lang="less">
.mb0{
	margin-bottom: 0;
}
.edit-warning{
	font-size: 14px;
	color: red;
	margin-right: 20px;
}
.errorMsg{
	font-size: 14px;
	color: red;
	float: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerGS/Edit.vue